export interface Props {
  value: SlateDocument;
}

// SlateJS Types
export interface BaseText {
  text: string;
  bold?: boolean;
  italic?: boolean;
  underline?: boolean;
  code?: boolean;
  [key: string]: unknown; // For other custom attributes
}

// Base element type that requires a "type" property
interface BaseElement {
  type: string;
  children: SlateNode[];
  [key: string]: unknown; // For other custom attributes
}

// Any Slate node is either an element or text
export type SlateNode = BaseElement | BaseText;

// Type for the complete document
export type SlateDocument = SlateNode[];

// Type guard to check if a node is a Text node
export function isText(node: SlateNode): node is BaseText {
  return 'text' in node;
}

// Type guard to check if a node is an Element
export function isElement(node: SlateNode): node is BaseElement {
  return !isText(node) && 'type' in node && Array.isArray((node as BaseElement).children);
}
